import React from "react";

export default function TableRow(props) {
  return <tr className={`c-table__row ${props.className}`}>{props.children}</tr>;
}
